// src/services/nfcAuthService.js

const API_BASE = process.env.REACT_APP_API_URL || '';

class NFCAuthService {
  constructor() {
    this.token = localStorage.getItem('nfcToken');
    this.userData = JSON.parse(localStorage.getItem('userData') || '{}');
  }
  
  async loginConCodigoNFC(codigoAcceso) {
    try {
      const response = await fetch(`${API_BASE}/api/auth/nfc-login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ codigoAcceso })
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al autenticar');
      }
      
      const data = await response.json();
      
      if (!data.success || !data.token) {
        throw new Error('Respuesta inválida del servidor');
      }
      
      this.token = data.token;
      this.userData = data.usuario || {};
      
      localStorage.setItem('nfcToken', data.token);
      localStorage.setItem('userType', 'nfc');
      localStorage.setItem('userId', data.userId || data.usuario?.id || '');
      localStorage.setItem('userData', JSON.stringify(data.usuario || {}));
      
      return {
        success: true,
        token: data.token,
        userId: data.userId || data.usuario?.id,
        usuario: data.usuario
      };
      
    } catch (error) {
      console.error('Error en login NFC:', error);
      return {
        success: false,
        error: error.message
      };
    }
  }

  // --- FUNCIÓN AÑADIDA ---
  // Esta función permite iniciar sesión programáticamente con los datos del "magic link".
  loginConDatos(token, usuario) {
    this.token = token;
    this.userData = usuario || {};
    
    // Guarda la nueva sesión en el almacenamiento local del navegador.
    localStorage.setItem('nfcToken', token);
    localStorage.setItem('userType', 'nfc');
    localStorage.setItem('userId', usuario?.id || '');
    localStorage.setItem('userData', JSON.stringify(usuario || {}));
  }
  
  async verificarCodigo(codigoAcceso) {
    try {
      const response = await fetch(`${API_BASE}/api/auth/verificar-codigo`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ codigoAcceso })
      });
      
      if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Error al verificar código');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error verificando código:', error);
      throw error;
    }
  }
  
  getAuthHeaders() {
  const token = this.token || localStorage.getItem('nfcToken');
  return token ? {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  } : {
    'Content-Type': 'application/json'
  };
}
  
  isAuthenticated() {
    return !!this.token;
  }
  
  getUserData() {
    // Leer directamente de localStorage para obtener valores actualizados
    // (por si fueron modificados después de la inicialización del servicio)
    return JSON.parse(localStorage.getItem('userData') || '{}');
  }
  
  getUserId() {
    return localStorage.getItem('userId') || this.userData?.id || null;
  }
  
  logout() {
    this.token = null;
    this.userData = {};
    localStorage.removeItem('nfcToken');
    localStorage.removeItem('userData');
    localStorage.removeItem('userType');
    localStorage.removeItem('userId');
    // ✅ Limpiar estado de PIN validado
    sessionStorage.removeItem('pinValidated');
    sessionStorage.removeItem('pinBypassed');
  }
}

export default new NFCAuthService();
